'use client';

import { Button, Icon } from '@chakra-ui/react';
import { useLayoutEffect, useRef } from 'react';
import { LuArrowLeft, LuArrowRight } from 'react-icons/lu';

interface Props {
  type: 'left' | 'right';
}

function onClick(e: React.MouseEvent<HTMLButtonElement>, direction: 'left' | 'right') {
  const target = e.target as HTMLButtonElement;
  const parent = target.closest('.slider-container') as HTMLDivElement;
  const slider = parent.querySelector('.slider') as HTMLDivElement;
  const childrenAverageWidth = Math.floor(slider.scrollWidth / slider.children.length);

  const { scrollLeft } = slider;

  // const scrollStep = Math.floor(slider.offsetWidth / childrenAverageWidth) * childrenAverageWidth || childrenAverageWidth;
  const scrollStep = childrenAverageWidth;

  slider.scrollTo({
    left: direction === 'left' ? scrollLeft - scrollStep + 10 : scrollLeft + scrollStep - 10,
    behavior: 'smooth',
  });
}

export default function SliderButton({ type }: Props) {
  const ref = useRef<HTMLButtonElement>(null);

  useLayoutEffect(() => {
    const parent = ref.current?.closest('.slider-container') as HTMLDivElement;
    const slider = parent.querySelector('.slider') as HTMLDivElement;

    // callback attached to the parent of the button
    const handleScroll = () => {
      if (!ref?.current) {
        return;
      }

      if (type === 'left') {
        ref.current.disabled = slider.scrollLeft < 50;
      } else {
        ref.current.disabled = slider.scrollLeft + slider.offsetWidth >= slider.scrollWidth - 50;
      }
    };

    // attach the scroll event to the slider
    slider.addEventListener('scroll', handleScroll);
    // call the function once to set the initial state
    handleScroll();
    // cleanup function to remove the event listener
    return () => {
      slider.removeEventListener('scroll', handleScroll);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Button
      ref={ref}
      size="lg"
      bgColor="primary.dark"
      color="white"
      position="absolute"
      left={
        type === 'left'
          ? {
              base: '1',
              lg: '0',
            }
          : {
              base: 'unset',
            }
      }
      right={
        type === 'right'
          ? {
              base: '1',
              lg: '0',
            }
          : {
              base: 'unset',
            }
      }
      zIndex={1}
      transform={type === 'left' ? 'translateX(-50%)' : 'translateX(50%)'}
      borderRadius="full"
      boxSize="10"
      p="0"
      minW="unset"
      onClick={(e) => onClick(e, type)}
    >
      <Icon boxSize="7">{type === 'left' ? <LuArrowLeft /> : <LuArrowRight />}</Icon>
    </Button>
  );
}
